/*
 * @version: 20220211
 * @Author: lcx
 * @Date: 2022-08-01 11:36:19
 * @LastEditors: zgy
 * @LastEditTime: 2022-08-03 17:35:52
 * @Description: description
 */
import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/Index'),  //首页
      meta: { title: '雅丽洁支付', requiresAuth: true ,hideHome:true}
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { title: '雅丽洁支付', hideHome:true}
    },

   {
        path: '/summary',
        component: () => import('@/views/Summary'),
        name: 'summary',
        meta: { title: '业绩汇总', requiresAuth: true,roles:['SuperAdmin','Admin']}
    },
    {
        path: '/orderflow',
        component: () => import('@/views/OrderFlow'),
        name: 'orderflow',
        meta: { title: '订单列表', requiresAuth: true ,roles:['SuperAdmin','Admin']}
    },

    {
        path: '/orderdetail/:id',
        component: () => import('@/views/OrderDetail'),
        name: 'orderdetail',
        meta: { title: '订单详情', requiresAuth: true ,roles:['SuperAdmin','Admin']}
    },

    {
        path: '/ordersend',
         component: () => import('@/views/OrderSend'),
        name: 'ordersend',
        meta: { title: '发送账单', requiresAuth: true ,roles:['SuperAdmin','Admin']}
    },
    {
        path: '/orderpay/:id',
        component: () => import('@/views/OrderPay'),
        name: 'orderpay',
        meta: { title: '缴费', requiresAuth: true ,hideHome:true}
    },

    {
        path: '/staff',
        component: () => import('@/views/Staff'), 
        name: 'staff',
        meta: { title: '员工绑定', requiresAuth: true ,roles:['SuperAdmin','Admin']}
    },

    {
        path: '/register',
        component: () => import('@/views/Register'), 
        name: 'register',
        meta: { title: '注册', requiresAuth: true,hideHome:true}
    },


   {
        path: '/unableplat',
        component: () => import('@/views/Unableplat'),
        name: 'unableplat',
        meta: { title: '雅丽洁支付' }
    },
    {
        path: '/404',
        component: () => import('@/views/Page404'),  //404页面
        meta: { title: '雅丽洁支付' }
    },

    {
        path: '/:pathMatch(.*)',
        redirect:'/404'
    }
  ]
})

export default router